import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  monthDayScaleLayoutCustom: {
    [theme.breakpoints.down('sm')]: { minWidth: '0px !important' },
  },
}));

export const MonthDayScaleLayoutCustom = (
  props: MonthView.DayScaleLayoutProps
) => {
  const { classes } = useStyles();

  return (
    <MonthView.DayScaleLayout
      {...props}
      className={classes.monthDayScaleLayoutCustom}
    ></MonthView.DayScaleLayout>
  );
};
